import React from 'react'
import { ReactComponent as IconSatis } from '../../../../../../../assets/icons/u_alert-check.svg'
import { OnePagerDoughnutChart } from '../../../../../../Portfolio_R/SummaryCharts/components/OnePagerDoughnutChart'

const PmrLonCard = ({ mp }) => {
    return (
        <div className="pmr">
            <div className='pmrIconContent'>
                <p>PMR</p>
                <IconSatis />
            </div>

            <OnePagerDoughnutChart data={mp.pmrArray} />
        </div>
    )
}

export default PmrLonCard